import BillingCycleToken from '@apps/subscriptions/admin/tokens/billing_cycle'
import StatusToken from '@admin/tokens/status'
import Panel from '@admin/components/panel'

const mapPropsToPanel = (props, context) => ({
  title: 't(Renewals)',
  collection: {
    endpoint: `/api/admin/subscriptions/services/${props.service.id}/subscriptions/${props.subscription.id}/renewals`,
    table: [
      { label: 't(ID)', key: 'id', collapsing: true, visible: false },
      { label: 't(Billing Cycle)', key: 'cycle_start_date', primary: true, format: BillingCycleToken },
      { label: 't(Total)', key: 'invoice.total', primary: true, collapsing: true, format: 'currency' },
      { label: 't(Status)', key: 'status', collapsing: true, primary: true, format: StatusToken  }
    ],
    defaultSort: { key: 'created_at', order: 'desc' },
    empty: {
      svg: 'repeat',
      title: 't(No Renewals)',
      text: 't(There have not yet been any renewals for this subscription)'
    },
    entity: 'renewal',
    onClick: (record) => context.router.push(`/admin/subscriptions/services/${props.service.id}/renewals/${record.id}`)
  }
})

export default Panel(null, mapPropsToPanel)
